"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var setup = function setup() {
  return {
    description: "Add a zip file with multiple YAML that describe the new ruleset.",
    flows: [{
      label: 'Upload a Ruleset',
      fields: [{
        name: 'mainFile',
        inputType: 'file',
        classifier: 'ruleset',
        extensions: ['.yaml'],
        required: true,
        hasMainFile: true,
        mainFileProperty: 'mainFile'
      }]
    }]
  };
};
var _default = exports.default = setup;
//# sourceMappingURL=form.js.map